import { cloneDeep } from 'lodash';

export const replaceValues = (obj: any, dynamicValues: any): any => {
    if (!dynamicValues) return obj;
    if (Array.isArray(obj)) {
        if (!!Array.isArray(dynamicValues)) {
            // vif json chi cho phep khai bao 1 phan tu dau tien dde dinh nghia ca array replace data

            return dynamicValues.map((dynamicItem: any, index: number) => {
                const item = cloneDeep(obj?.[0]);
                return replaceValues(cloneDeep(item), dynamicItem);
            });
        } else {
            return obj;
        }
        // Xử lý từng phần tử trong mảng
    } else if (typeof obj === 'object' && obj !== null) {
        for (let key in obj) {
            if (typeof obj[key] === 'string' && obj[key].startsWith('[$') && obj[key].endsWith(']')) {
                let variableName = obj[key].slice(2, -1);
                if (dynamicValues.hasOwnProperty(variableName)) {
                    obj[key] = dynamicValues[variableName];
                }
            } else if (Array.isArray(obj[key])) {
                obj[key] = replaceValues(obj[key], dynamicValues?.[key]); // Xử lý mảng lồng nhau
            } else if (typeof obj[key] === 'object') {
                obj[key] = replaceValues(obj[key], dynamicValues?.[key]); // Xử lý đối tượng lồng nhau
            }
            // Các trường không thay đổi sẽ không bị ảnh hưởng
        }
    }
    return obj;
};

/**
   * Replaces variants in the given content based on the provided payload.
   *
    - [$productName]: Tên của sản phẩm. Ví dụ: "Ly Sứ Cá Nhân Hóa"
    - [$productDescription]: Mô tả ngắn về sản phẩm. Ví dụ: "Ly sứ chất lượng cao có thể cá nhân hóa với tên hoặc thông điệp của bạn."
    - [$sku]: Mã SKU, một mã nhận dạng duy nhất cho sản phẩm. Ví dụ: "AM12345"
    - [$imageURL]: Địa chỉ hình ảnh cảm bản cho sản phẩm. Ví dụ: "https://api.amarebox.com/media/canawan/default/AVIF_to_PNG_conversion_result.png"
   
    */

export const processJsonSchema = (schemaConfig: any, dynamicValues: any) => {
    try {
        const result = replaceValues(JSON.parse(schemaConfig), dynamicValues);
        return JSON.stringify(result);
    } catch (error) {
        return schemaConfig;
    }
};
